/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const AddMyPhoneResponse = zod.object({
  phones: zod.array(
    zod.object({
      phoneNumber: zod.string().describe('The phone number in E.164 format'),
      primary: zod.boolean().describe('True for the primary number (the profile phone number)'),
      verified: zod.boolean().describe('True once the number has passed SMS OTP verification'),
    }),
  ),
  verification: zod
    .object({
      csrfToken: zod.string(),
      expiresAt: zod.string(),
      flowId: zod.string().min(1),
      phoneNumber: zod.string(),
    })
    .optional()
    .describe(
      'Verification flow state to echo back on \/me\/phones\/verify. Absent when the OTP SMS could not be dispatched (the number was still added; use \/me\/phones\/resend).',
    ),
});

export type AddMyPhoneResponse = zod.input<typeof AddMyPhoneResponse>;
export type AddMyPhoneResponseOutput = zod.output<typeof AddMyPhoneResponse>;
